import styles from './QRCodeModal.module.css';
import QRCode from 'qrcode.react';
import { createPortal } from 'react-dom';

export const QRCodeModal: React.FC<{ onClose: (e: React.MouseEvent<HTMLDivElement>) => void }> = ({
  onClose,
}) => {
  const currentUrl = window.location.href;

  return createPortal(
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.content}>
          <div className={styles.qrContainer}>
            <QRCode value={currentUrl} size={280} level="H" includeMargin={true} />
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};
